// extracted by mini-css-extract-plugin
export default {"bubble":"TaskGridTags_bubble__ahKCY"};